import { useTeam } from 'app/frontend/base/config/context/team'
import { useOverviewData } from 'app/frontend/base/config/queries'
import TileWrapper from '../TileWrapper'
import { difficultiesLabels } from 'app/frontend/types/custom/Difficulty'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'

const RaidProgressTile = () => {
  const { team } = useTeam()
  const { data: overviewData } = useOverviewData(team.id)

  if (!overviewData?.raidProgress)
    return (
      <TileWrapper>
        <p className='text-muted-foreground'>No raid progress found</p>
      </TileWrapper>
    )

  return (
    <TileWrapper>
      <div className='text-lg flex items-center gap-2 justify-center'>
        <Tooltip>
          <TooltipTrigger>
            <img
              className='w-8 h-8 rounded-full border border-background mr-1'
              src={overviewData.raidProgress.instance.legacyImagePath}
            />
          </TooltipTrigger>
          <TooltipContent>
            {overviewData.raidProgress.instance.name}
          </TooltipContent>
        </Tooltip>
        <span>
          <span>{overviewData.raidProgress.kills}</span> /{' '}
          {overviewData.raidProgress.total}
        </span>
        {difficultiesLabels[overviewData.raidProgress.difficulty]}
      </div>
    </TileWrapper>
  )
}

export default RaidProgressTile
